<div *ngIf="selecionado">
  <app-despesa-cadastro
    [model]="selecionado"
    (buscar)="buscar($event)"
    [state]="state">
  </app-despesa-cadastro>
</div>
<div *ngIf="!selecionado">
  <app-despesa-filtro [filtros]="filtros"></app-despesa-filtro>
  <app-despesa-lista
    [filtros]="filtros"
    (exibir)="selecionar($event)"
    (definirFiltro)="definirFiltro()">
  </app-despesa-lista>
</div>